import { createContext } from 'react'

import {
  createDispatchHook,
  createSelectorHook,
  createStoreHook
} from 'react-redux'

import {
  buildCreateApi,
  coreModule,
  reactHooksModule
} from '@reduxjs/toolkit/query/react'

const context = createContext({})
const useHeaderSelector = createSelectorHook(context)
const useHeaderDispatch = createDispatchHook(context)
const useHeaderStore = createStoreHook(context)

const createApi = buildCreateApi(
  coreModule(),
  reactHooksModule({
    useDispatch: useHeaderDispatch,
    useSelector: useHeaderSelector,
    useStore: useHeaderStore
  })
)

export {
  context,
  createApi,
  useHeaderDispatch,
  useHeaderSelector,
  useHeaderStore
}
